module.exports = __webpack_public_path__ + "img/icon3.c30ea311.svg";